import { SIMPANAN_INVESTASI } from "../../constants/admin/masterdata/constants";

const initialState = {
  cache: {},
  queryKey: null,
  selectedIds: [],
  isModalAction: false,
  loadingGetSimpananInvestasi: true,
  loadingActionSimpananInvestasi: false,
  dataSimpananInvestasi: { count: 0, data: [] },
};

export const simpananInvestasiReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIMPANAN_INVESTASI.GET_DATA_SIMPANAN_INVESTASI_SUCCESS:
      return {
        ...state,
        dataSimpananInvestasi: action.data,
      };

    case SIMPANAN_INVESTASI.LOADING_DATA_SIMPANAN_INVESTASI_SUCCESS:
      return {
        ...state,
        loadingGetSimpananInvestasi: action.load,
      };

    case SIMPANAN_INVESTASI.LOADING_ACTION_SIMPANAN_INVESTASI:
      return {
        ...state,
        loadingActionSimpananInvestasi: action.load,
      };

    case SIMPANAN_INVESTASI.IS_MODAL_ACTION_SIMPANAN_INVESTASI:
      return {
        ...state,
        isModalAction: action.load,
      };

    // Selection
    case SIMPANAN_INVESTASI.SET_QUERY_KEY: {
      if (state.queryKey !== action.key) {
        return { ...state, queryKey: action.key, selectedIds: [] };
      }
      return state;
    }

    case SIMPANAN_INVESTASI.ADD_SELECTED_IDS: {
      const set = new Set(state.selectedIds);
      (action.ids || []).forEach((id) => set.add(id));
      return { ...state, selectedIds: Array.from(set) };
    }

    case SIMPANAN_INVESTASI.REMOVE_SELECTED_IDS: {
      const removeSet = new Set(action.ids || []);
      const next = state.selectedIds.filter((id) => !removeSet.has(id));
      return { ...state, selectedIds: next };
    }

    case SIMPANAN_INVESTASI.CLEAR_SELECTED_IDS:
      return { ...state, selectedIds: [] };

    // Cache
    case SIMPANAN_INVESTASI.SET_CACHE_ENTRY: {
      const { key, data } = action;
      return {
        ...state,
        cache: {
          ...state.cache,
          [key]: { data, fetchedAt: Date.now(), loading: false },
        },
        dataSimpananInvestasi: data,
        loadingGetSimpananInvestasi: false,
      };
    }

    case SIMPANAN_INVESTASI.SET_LOADING_FOR_KEY: {
      const { key, loading } = action;
      const prev = state.cache[key] || {};
      return {
        ...state,
        cache: { ...state.cache, [key]: { ...prev, loading } },
        loadingGetSimpananInvestasi: loading,
      };
    }

    case SIMPANAN_INVESTASI.UPDATE_CACHE_ITEMS: {
      const { changesById } = action; // { [id]: { ...partial } }
      const nextCache = {};
      for (const k in state.cache) {
        const entry = state.cache[k];
        if (!entry?.data?.data) {
          nextCache[k] = entry;
          continue;
        }
        const newList = entry.data.data.map((row) =>
          changesById[row.id] ? { ...row, ...changesById[row.id] } : row
        );
        nextCache[k] = {
          ...entry,
          data: { ...entry.data, data: newList },
        };
      }
      const activeList = state.dataSimpananInvestasi?.data || [];
      const newActive = activeList.map((row) =>
        changesById[row.id] ? { ...row, ...changesById[row.id] } : row
      );
      return {
        ...state,
        cache: nextCache,
        dataSimpananInvestasi: {
          ...state.dataSimpananInvestasi,
          data: newActive,
        },
      };
    }

    default:
      return state;
  }
};
